import { PUBLIC_SHORTLIST_SETTINGS_ID } from '@/modules/public-shortlist/constants';
import type { JobApi } from '@/modules/jobs/types';

type PublicShortlistJob = Pick<
  JobApi,
  'publicCandidateListCode' | 'publicCandidateListUrl' | 'company' | 'title'
>;

export function isPublicShortlistAvailable(job: PublicShortlistJob): boolean {
  return Boolean(job.publicCandidateListUrl || job.publicCandidateListCode);
}

function toUrlSlug(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-');
}

export function fromUrlSlug(slug: string): string {
  return slug
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function getPublicShortlistUrl(job: PublicShortlistJob): string | null {
  if (job.publicCandidateListUrl) {
    return job.publicCandidateListUrl;
  }

  if (!job.publicCandidateListCode) {
    return null;
  }

  const companySlug = toUrlSlug(job.company?.name ?? '');
  const roleSlug = toUrlSlug(job.title ?? '');
  if (!companySlug || !roleSlug) {
    return null;
  }

  const url = new URL(
    `/${companySlug}/shortlist/${roleSlug}`,
    window.location.origin,
  );
  url.searchParams.set('code', job.publicCandidateListCode);

  return url.toString();
}

export function getPublicShortlistEditPath(jobId: string): string {
  return `/jobs/${jobId}/edit#${PUBLIC_SHORTLIST_SETTINGS_ID}`;
}
